@if (timeOut()) {
  <app-timeout></app-timeout>
} @else if (loading()) {
  <div class="flex justify-content-center align-items-center h-full">
    <p-progressSpinner ariaLabel="loading" class="customProgressSpinner" />
  </div>
} @else {
  @if (serviceListConfig) {
    <div class="contractsList component-list">
      <div class="header">
        <div class="icon-container">
          <app-svg-icon
            (click)="navigateToDetail()"
            [iconName]="serviceListConfig.icon"
            iconSize="xl"
            iconColor="primary"
            class="pointer"
          ></app-svg-icon>
        </div>
        <div (click)="navigateToDetail()" class="title-container pointer">
          <span>{{ serviceListConfig.title | translate }}</span>
        </div>
        <div class="tab-buttons">
          @for (tab of tabs(); track tab) {
            <span
              class="tab-btn"
              (click)="selectTab(tab.value)"
              [ngClass]="{ selected: tab.value === selectedTab() }"
              >{{ tab.label | translate }}</span
            >
          }
        </div>
      </div>
      <div class="content">
        <table>
          <tr>
            @for (column of columns(); track column) {
              <th>{{ column | translate }}</th>
            }
          </tr>

          @for (entry of displayedEntries(); track entry) {
            <tr>
              @for (colEntry of entry; let i = $index; track colEntry) {
                @if (isNumber(colEntry)) {
                  <td>{{ getNumber(colEntry) | number: "" : "de" }}</td>
                } @else if (type() === "predictive" && i === 0) {
                  <td
                    class="cursorDefault"
                    [pTooltip]="
                      gateIdentifierPipe.transform(
                        getGateSystemRef(colEntry),
                        permissions.hasPermission(permissions.allPermissions.ASSET_MASTER_DATA_CREATE)
                      )
                    "
                    tooltipPosition="bottom"
                  >
                    {{ getGateSystemRef(colEntry).label }} ...
                  </td>
                } @else {
                  <td>{{ colEntry }}</td>
                }
              }
            </tr>
          }
        </table>
      </div>
    </div>
  }
}
